// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3jrO8","boxTitle":"Qualiphy_boxTitle__2J2wb","box":"Qualiphy_box__2-M_z","toggleWrap":"Qualiphy_toggleWrap__1kY0D"};